import { useState } from "react";
import { Player, TrainingProposal } from "../api/types.tsx";
import { formationService } from "../api/service.ts";

const MIN_FORMATION_PLAYERS = 6;
const MIN_TRAINING_PLAYERS = 8;

export function useFormationGeneration(selectedIds: number[], players: Player[]) {
    const [loading, setLoading] = useState(false);
    const [results, setResults] = useState<any[]>([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [generationType, setGenerationType] = useState<"all" | "topN" | "topNEveryone">("all");
    const [topN, setTopN] = useState(0);
    const [openGenerationDialog, setOpenGenerationDialog] = useState(false);

    const [trainingTeams, setTrainingTeams] = useState<TrainingProposal | null>(null);
    const [openTrainingDialog, setOpenTrainingDialog] = useState(false);
    const [openSetterDialog, setOpenSetterDialog] = useState(false);
    const [availableSetters, setAvailableSetters] = useState<Player[]>([]);
    const [selectedSetters, setSelectedSetters] = useState<number[]>([]);

    const openFormationDialog = () => {
        if (selectedIds.length < MIN_FORMATION_PLAYERS) {
            alert(`Seleziona almeno ${MIN_FORMATION_PLAYERS} giocatori!`);
            return;
        }
        setOpenGenerationDialog(true);
    };

    const generateFormations = async () => {
        setLoading(true);
        try {
            const res = await formationService.getBestFormations(selectedIds, { type: generationType, topN });
            setResults(res);
            setOpenDialog(true);
        } catch (err) {
            console.error(err);
            alert("Errore nella generazione delle formazioni");
        } finally {
            setLoading(false);
        }
    };

    const generateTrainingTeams = async () => {
        if (selectedIds.length < MIN_TRAINING_PLAYERS) {
            alert(`Seleziona almeno ${MIN_TRAINING_PLAYERS} giocatori!`);
            return;
        }

        const selectedPlayers = players.filter((p) => selectedIds.includes(p.id));
        const setters = selectedPlayers.filter((p) => p.roles.some((r) => r.toLowerCase().includes("palleggi")));

        if (setters.length > 2) {
            setAvailableSetters(setters);
            setSelectedSetters([]);
            setOpenSetterDialog(true);
            return;
        }

        if (setters.length < 2) {
            alert("Seleziona almeno 2 palleggi!");
            return;
        }

        await invokeTrainingService(setters.map((s) => s.id));
    };

    const invokeTrainingService = async (setterIds: number[]) => {
        setLoading(true);
        try {
            const res = await formationService.getTrainingTeams(selectedIds, setterIds);
            setTrainingTeams(res);
            setOpenTrainingDialog(true);
        } catch (err) {
            console.error(err);
            alert("Errore nella generazione delle squadre di allenamento");
        } finally {
            setLoading(false);
        }
    };

    return {
        loading,
        results,
        openDialog,
        setOpenDialog,
        generationType,
        setGenerationType,
        topN,
        setTopN,
        openGenerationDialog,
        setOpenGenerationDialog,
        openFormationDialog,
        generateFormations,
        trainingTeams,
        openTrainingDialog,
        setOpenTrainingDialog,
        openSetterDialog,
        setOpenSetterDialog,
        availableSetters,
        selectedSetters,
        setSelectedSetters,
        generateTrainingTeams,
        invokeTrainingService,
    };
}
